import SpotDisplay from './SpotDisplay'

export default SpotDisplay